import { useEffect, useState } from "react";
import { cn } from "~/lib/utils";
import MobileHeader from "./mobile-header";
import MobileFooter from ".//mobile-footer";
import { useNavigate, useSearchParams } from "@remix-run/react";
import { FBProfile } from "~/.server/api";

interface InnerViewProps {
  showHeader?: boolean;
  showFooter?: boolean;
  children: React.ReactNode;
  title?: string;
  id: string;
  open?: boolean;
  user?: FBProfile;
}

export default function InnerView({
  title,
  showHeader = true,
  showFooter = true,
  children,
  id,
  open = false,
  user,
}: InnerViewProps) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [isVisible, setIsVisible] = useState(open);
  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    if (searchParams.get("view") === id) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [searchParams]);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      setIsOpen(true);
    } else {
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 300); // Match this with your transition duration
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!isVisible) return null;

  return (
    <>
      {/* Overlay */}
      {isVisible && (
        <div
          className={cn(
            "fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm transition-opacity duration-300",
            isOpen ? "animate-fadeIn" : "animate-fadeOut",
            "z-40"
          )}
          onClick={() => {
            setIsOpen(false);
            navigate(-1); // Close the InnerView when the overlay is clicked
          }}
        />
      )}

      {/* InnerView */}
      {isVisible && (
        <div
          className={cn(
            "fixed top-0 bg-background text-primary z-50 flex flex-col w-screen md:w-1/2 md:left-1/2 md:-translate-x-1/2 ",
            isOpen
              ? "animate-slideInFromLeft md:animate-fadeIn"
              : "animate-slideOutToLeft md:animate-fadeOut",
            "h-dvh md:h-auto md:max-h-[95vh] md:top-1/2 md:-translate-y-1/2 md:rounded-lg md:shadow-lg",
            "md:ring-1 md:ring-white"
          )}
        >
          {showHeader && (
            <MobileHeader
              showBack={true}
              onBackClick={() => {
                setIsOpen(false);
                navigate(-1);
              }}
              user={user}
              showPromotion={false}
            >
              {title}
            </MobileHeader>
          )}
          <div className="overflow-y-auto flex-1">{children}</div>
          {showFooter && <MobileFooter messageCount={10} user={user} />}
        </div>
      )}
    </>
  );
}
